<div class="input-group mb-3 form-group">

  <span *ngIf="icon" class="input-group-addon">
    <i class="fa" [ngClass]="icon ? 'fa-'+ icon : ''" aria-hidden="true"></i>
  </span>

  <input class="form-control" [type]="type" [name]="name" [placeholder]="placeholder" [formControl]="control"
    [ngClass]="{'alert-danger': showError}" ngDefaultControl>

  <span *ngIf="showError">&nbsp;
    <i class="fa fa-exclamation-circle font-danger error-icon" aria-hidden="true"></i>
  </span>
</div>